import * as React from "react";
import "./Login.css";
import logo from "../../assets/logo_w.png";
import Slideshow from "./Slideshow";
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { toast } from "react-toastify";

export default class ClientSignup extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      contactName: "",
      taxId: "",
      email: "",
      phone: "",
      password: "",
      name: "",
      zip: "",
      expiry: "",
      cardNumber: "",
      cardName: "",
      cvc: "",
      error: "",
      focus: null,
      planId: null,
      step: 0,
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.account = null;
    window.localStorage.setItem("account", "{}");
  }

  handleInputFocus = (e:any) => {
    let name  = e.target.name;
    if(name.includes("name")) name = "name";
    if(name.includes("number")) name = "number";
    this.setState({focus: name});
  }

  handleChange(event: any) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  signup() {
    this.setState({loading: true})
    fetch("public/clientSignup", {
      method: "post",
      body: JSON.stringify(this.state),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({loading: false})
        toast.success("נרשם בהצלחה. אנא אשר את המייל")
        this.props.history.push("/client/login");
      })
      .catch((error) => {
        this.setState({loading: false})
        this.setState({ error: error.message });
      });
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  public render() {
    return (
      <div id="login-root" className="signup">
                  <a className="privacy" target="_blank" href="https://www.sharemedia.co.il/en/privacy/">תקנון פרטיות</a>

        <div className="right">
          <form>
            <img className="main_logo" src={logo} />

            {this.state.step === 0 && <div>
              <p>ברוכים הבאים למערכת מכירות המשפיענים של SHARE
              <br/><br/>
המערכת נבתנה במיוחד עבור אתרי איקומרס שמפרסמים דרך משפיענים ומאגדת בשבילכם את כל המידע שאתם צריכים במקום אחד, בצורה נוחה, נגישה ואינטרקטיבית.
מחפשים פתרון שעובד בשבילכם? בהצטרפות מהירה וקלה, תוכלו להיות חלק מנבחרת אתרי אינטרנט שכבר עושים את זה נכון.
דרך המערכת תוכלו לנהל את מאגר המשפיענים שלכם, לעקוב אחר לינקים מקודדים וקודי קופון, לנהל מודל אפיליאציה ולהתעדכן בזמן אמת על ביצועים, הקלקות, מכירות ועוד.
איך מתקדמים? מלאו את הפרטים מטה ובואו נתחיל!
נתקלתם בבעיה? יש לכם שאלות נוספות? דברו איתנו: <a href="mailto:office@sharemedia.co.il">office@sharemedia.co.il</a></p>
            <br/><br/>
              <input
                type="text"
                autoFocus
                className="form-control"
                name="name"
                placeholder={"שם המותג"}
                value={this.state.name}
                onChange={this.handleChange}
              />
              <input
                type="text"
                autoFocus
                className="form-control"
                name="contactName"
                placeholder={"שם איש הקשר"}
                value={this.state.contactName}
                onChange={this.handleChange}
              />
              <input
                type="text"
                autoFocus
                className="form-control"
                name="taxId"
                placeholder={"ח.פ."}
                value={this.state.taxId}
                onChange={this.handleChange}
              />
              <input
                type="text"
                autoFocus
                className="form-control"
                name="phone"
                placeholder={"טלפון"}
                value={this.state.phone}
                onChange={this.handleChange}
              />
              <input
                type="email"
                autoFocus
                className="form-control"
                name="email"
                placeholder={"אימייל"}
                value={this.state.email}
                onChange={this.handleChange}
              />
              <input
                type="password"
                className="form-control"
                name="password"
                placeholder={"סיסמה"}
                value={this.state.password}
                onChange={this.handleChange}
              />
              <button
                type="button"
                className={"primary-btn" + (this.validateForm() ? "" : " off")}
                disabled={!this.validateForm()}
                onClick={() => {
                  this.setState({step: 1})
                }}
              >
                המשך
              </button>
            </div>}
            {this.state.step === 1 && <div>
              <p>בעזרת המערכת תוכלו לשפר את השקיפות מול יוצרי התוכן והמשפיענים איתם אתם עובדים ע"י אספקת נתונים חיים ומהימנים ובכך להגביר את המוטביציה שלהם לעבוד מולכם וליצור תוכן איכותי.
נשמע טוב מידי כדי להיות אמיתי? נסו את המנוי החודשי.
מוכנים לחיים נוחים יותר? מחכים לכם במנוי השנתי.</p>
<br/><br/>
              <div className={this.state.planId === 2845919? "plan active" : "plan"} onClick={() => {
                this.setState({planId: 2845919})
              }}>
                חבילה חודשית
                <span>₪299</span>
              </div>
              <div className={this.state.planId === 2845921? "plan active" : "plan"} onClick={() => {
                this.setState({planId: 2845921})
              }}>
                חבילה שנתית
                <span>₪259</span>
              </div>
              <button
                type="button"
                className={"primary-btn"}
                onClick={() => {
                  this.setState({step: 2})
                }}
              >
                המשך
              </button>
            </div>}
            {this.state.step === 2 && <div>
              <p>
              הקנייה באתר מאובטחת ב100% בטכנולוגיית הצפנה מתקדמת (דפי SSL) אשר מאפשר רכישה מקוונת באופן מאובטח עם שמירה על מידע הלקוח ומניעת מסירת מידע לצד ג'
מכבדים את כל סוגי כרטיסי האשראי- ניתן לרכוש באתר בעזרת כרטיס אשראי ישראלי תקף, מסוג ויזה, ישראכארט או אמריקן אקספרס, שהונפק על ידי אחת מחברות כרטיסי האשראי המוכרות, וחברת האשראי אישה את ביצוע העסקה. 
הנתונים של כרטיסי האשראי לא נשמרים בשרתי החברה. חברות אשראי וחברות סליקה בודקות בצורה מחמירה את בתי העסק שעבורם הן מספקות שרות. האתר עומד בתקני אבטחת המידע מהמחמירים שיש – קנייה חכמה ובטוחה 
              </p>
              <br/><br/>
              <Cards
                  cvc={this.state.cvc}
                  expiry={this.state.expiry}
                  focused={this.state.focus}
                  name={this.state.cardName}
                  number={this.state.cardNumber}
              />
              <input
                type="text"
                className="form-control"
                name="cardName"
                placeholder={"שם בעל הכרטיס"}
                value={this.state.cardName}
                onChange={this.handleChange}
              />
              <input
                type="text"
                className="form-control"
                name="cardNumber"
                placeholder={"מספר כרטיס אשראי"}
                value={this.state.cardNumber}
                onChange={this.handleChange}
              />
              <input
                type="text"
                className="form-control"
                name="expiry"
                style={{width: "38%", display: "inline-block", float: "right", marginRight: "10%"}}
                placeholder={"תוקף"}
                value={this.state.expiry}
                onChange={this.handleChange}
              />
              <input
                type="text"
                className="form-control"
                name="cvc"
                style={{width: "38%", display: "inline-block", float: "left", marginLeft: "10%"}}
                placeholder={"CVC"}
                value={this.state.cvc}
                onChange={this.handleChange}
              />
              <button
                type="button"
                className={"primary-btn" + (this.validateForm() ? "" : " off")}
                disabled={!this.validateForm()}
                onClick={()=> {this.signup()}}
              >
                {this.state.loading? "אנא המתן.." : "הרשמה"}
              </button>
            </div>}
            <h5>{this.state.error}</h5>
          </form>
        </div>
        <Slideshow />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/ClientSignup.tsx